// @ts-nocheck
import { createAction, createAsyncAction } from '../../../core/store/actionCreators';
import {
  CANCEL_ORDER,
  DESELECT_ORDER,
  FETCH_ORDER,
  FETCH_ORDERS,
  REFUND_ORDER,
} from './orderActionTypes';
import OrderService from '../services/OrderService';

export const fetchOrders = createAsyncAction(
  FETCH_ORDERS,
  async (userId, orderStatus, pageNr, pageSize) => {
    const { data } = await OrderService.fetchOrders(userId, orderStatus, pageNr, pageSize);
    return data;
  }
);

export const fetchOrder = createAsyncAction(FETCH_ORDER, async (orderId, type) => {
  const { data } = await OrderService.fetchOrder(orderId, type);
  return data;
});

export const refundOrder = createAsyncAction(REFUND_ORDER, async (userId, orderId, amount) => {
  const { data } = await OrderService.refundOrder(userId, orderId, amount);
  return data;
});

export const cancelOrder = createAsyncAction(CANCEL_ORDER, async (userId, orderId) => {
  const { data } = await OrderService.cancelOrder(userId, orderId);
  return data;
});

export const deselectOrder = createAction(DESELECT_ORDER);
